var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtaBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 960 540",
    width: 960,
    height: 540,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -12.3L2.8 -3.8L11.7 -3.8L4.5 1.4L7.2 9.9L0 4.7L-7.2 9.9L-4.5 1.4L-11.7 -3.8L-2.8 -3.8Z",
    transform: "translate(401 319)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(902 138)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(427 138)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(554 500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(85 76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(2 36)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(839 300)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(782 371)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(613 353)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(13 508)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(320 37)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(792 445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(820 242)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(139 364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(811 415)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(848 176)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(476 271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(710 288)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(540 222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(463 364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(857 440)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(190 425)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(327 461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(745 207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(363 24)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(332 218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(116 376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(689 446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(656 518)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(152 499)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(655 295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(821 339)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(775 44)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(549 29)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(382 219)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(179 113)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(539 56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(87 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(596 70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(402 197)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(787 404)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(15 65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(338 91)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(655 438)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(316 147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(931 429)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(935 98)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(659 131)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(374 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(493 348)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(613 311)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(360 151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(493 81)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(397 242)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(557 294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(418 480)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(925 368)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(866 94)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(484 150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(550 81)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(358 467)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(111 409)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(413 31)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(201 51)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(50 102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(750 317)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(843 49)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(860 235)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(214 27)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(79 165)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(950 52)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(109 477)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(833 429)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(161 83)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(620 478)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(777 298)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(903 301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(304 386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(167 437)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(248 362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(813 21)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(495 506)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(463 457)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(876 347)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(665 375)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(453 404)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(748 449)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(550 448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(761 9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(241 232)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(55 216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(41 431)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(843 375)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(68 443)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(55 488)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(734 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(383 92)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(298 349)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(164 393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(684 228)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(558 391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(55 395)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(776 472)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(333 323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(54 346)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(123 162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(334 254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(503 311)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(207 143)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(932 525)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(200 293)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(403 120)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(614 282)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(893 256)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(716 40)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(463 176)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(729 504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(696 531)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(430 420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(355 531)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(450 537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(261 206)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(182 193)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(3 364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(506 119)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(692 496)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(23 331)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(660 330)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(801 267)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(744 237)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(4 120)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(268 318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(688 321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(288 258)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(387 479)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(192 491)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(475 4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(880 380)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(367 274)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(250 9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(245 535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(563 120)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(880 523)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(380 453)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(471 111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(736 416)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(448 498)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(487 40)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(295 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(380 356)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(846 517)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(889 430)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(620 176)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(164 31)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(264 149)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(456 89)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(176 251)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(530 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(217 110)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(15 260)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(588 396)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(288 299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(555 349)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(523 372)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(740 177)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(858 120)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(1 87)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(691 85)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(252 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(187 15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(356 227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(322 435)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(629 407)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(269 97)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(616 206)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(703 249)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(259 290)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(535 263)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(428 57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(878 476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(199 453)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(299 483)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(203 514)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(268 49)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(776 501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(493 199)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(552 322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(921 332)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(665 462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(603 129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(615 518)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(940 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(488 395)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(802 146)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(228 381)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(174 314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(231 486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(327 529)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(80 404)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(509 533)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(3 484)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(312 281)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(379 178)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(160 527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(692 361)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(690 44)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(705 397)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(897 170)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(59 256)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(55 525)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(876 10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(561 529)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(949 486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(586 202)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(725 336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(92 272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(10 411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(510 250)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(230 333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(425 99)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(174 356)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(26 235)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(777 528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(617 92)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(135 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(270 523)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(244 174)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(473 424)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(486 226)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(717 109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(96 441)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(781 206)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(3 200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(121 15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(789 344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(651 2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(60 146)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(296 60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(368 60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(764 150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(138 331)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(423 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(46 167)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(81 18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(629 115)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(247 70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(641 351)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(835 108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(447 204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(85 514)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(162 219)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(806 104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(330 366)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(812 63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(426 448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(635 68)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(105 49)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(799 173)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(271 233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(560 161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(270 412)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(900 105)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(358 496)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(28 139)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(300 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(122 512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(275 472)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(913 466)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(347 300)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(285 184)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(680 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(660 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(817 450)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(918 198)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(459 46)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(452 304)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(87 359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(405 163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(34 18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(439 380)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(103 203)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(126 103)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(330 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(453 334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(332 123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(200 328)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(918 228)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(122 68)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(58 287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(561 263)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(921 501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(134 444)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(652 101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(166 277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(564 419)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(435 2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(850 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(760 90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(215 357)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(757 120)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(425 330)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(609 13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(138 292)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(636 237)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(636 536)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(146 474)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(201 217)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(57 318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(424 530)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(517 411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(100 243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(393 400)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(214 415)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(886 228)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(24 304)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(179 139)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(528 500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(642 161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(12 167)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(591 338)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(332 14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(806 213)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(95 133)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(655 31)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(612 246)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(528 189)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(807 511)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(521 330)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(427 225)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(932 149)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(701 8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(735 385)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(761 257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(303 412)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(63 38)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(953 250)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(684 149)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(843 259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(872 151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(942 305)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(263 444)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(200 169)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(479 534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(504 444)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(732 267)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(853 488)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(248 127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(191 392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(110 295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(726 153)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(476 484)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(391 287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(109 342)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(736 537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(465 240)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(381 512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(585 241)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(218 259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(196 89)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(363 380)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(417 367)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(420 298)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(218 72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(594 173)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(731 6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(949 396)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(878 286)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(597 448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(297 105)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(352 430)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(301 525)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(905 536)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(569 2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(222 440)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(316 77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(624 445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(654 486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(927 70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(572 464)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(655 257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(757 360)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(788 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(917 25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(177 60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(837 204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(153 158)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(523 467)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(257 499)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(122 133)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(573 49)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(846 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(341 396)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(753 287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(77 468)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(870 55)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(867 309)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(735 477)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(533 112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(220 196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(907 389)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(230 284)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(63 190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(707 200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(805 386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(8 443)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(326 494)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(138 200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(517 287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(956 282)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(585 272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(671 401)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(715 440)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(942 175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(954 199)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(915 270)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(769 426)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(272 380)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(401 71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(521 26)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(958 447)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(582 498)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(241 423)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(950 362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(590 528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(142 418)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(289 439)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(623 40)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(313 237)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(841 148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(33 463)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(271 347)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(578 142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(895 74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(148 8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(456 138)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(692 116)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(386 140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(763 391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(380 426)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(617 382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(719 225)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(709 469)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(845 78)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(134 37)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(31 539)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(681 286)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(150 124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(477 316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(358 341)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(3 285)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(336 57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(514 217)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(80 221)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(950 120)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(898 362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(824 480)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(408 509)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(863 198)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(810 302)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(520 79)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(249 466)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(26 384)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(45 56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(75 113)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(958 84)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(502 169)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(425 179)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(588 98)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(389 13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(868 408)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(359 200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(584 24)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(574 367)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(29 187)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(565 187)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(239 38)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(580 310)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(3 532)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(770 179)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(132 536)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(176 465)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(662 67)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(894 40)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(789 243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(6 9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(893 497)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(777 70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(396 539)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(697 421)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(748 39)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(359 125)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(808 538)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(124 224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(955 22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(96 538)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(218 537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(608 422)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(958 421)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(639 195)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(705 173)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(288 136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(946 224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(958 533)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(240 309)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(241 97)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(23 103)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(783 115)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(138 391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10.4L2.3 -3.2L9.9 -3.2L3.8 1.2L6.1 8.4L0 4L-6.1 8.4L-3.8 1.2L-9.9 -3.2L-2.3 -3.2Z",
    transform: "translate(307 320)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(892 325)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(890 199)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(536 3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(454 21)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(219 2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(449 264)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(958 337)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(59 3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(835 401)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6.6L1.5 -2L6.3 -2L2.4 0.8L3.9 5.3L0 2.5L-3.9 5.3L-2.4 0.8L-6.3 -2L-1.5 -2Z",
    transform: "translate(958 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(28 358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(904 3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(275 19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(100 97)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.6L1.7 -2.3L7.2 -2.3L2.7 0.9L4.4 6.1L0 2.9L-4.4 6.1L-2.7 0.9L-7.2 -2.3L-1.7 -2.3Z",
    transform: "translate(1 318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(186 538)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(567 220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.7L1.3 -1.7L5.4 -1.7L2.1 0.7L3.3 4.6L0 2.2L-3.3 4.6L-2.1 0.7L-5.4 -1.7L-1.3 -1.7Z",
    transform: "translate(498 14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8.5L1.9 -2.6L8.1 -2.6L3.1 1L5 6.9L0 3.2L-5 6.9L-3.1 1L-8.1 -2.6L-1.9 -2.6Z",
    transform: "translate(799 486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -4.7L1.1 -1.5L4.5 -1.5L1.7 0.6L2.8 3.8L0 1.8L-2.8 3.8L-1.7 0.6L-4.5 -1.5L-1.1 -1.5Z",
    transform: "translate(922 121)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -9.4L2.1 -2.9L9 -2.9L3.4 1.1L5.5 7.6L0 3.6L-5.5 7.6L-3.4 1.1L-9 -2.9L-2.1 -2.9Z",
    transform: "translate(390 45)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtaBg);
export default __webpack_public_path__ + "static/media/cta-bg.3d011ebfe71e0f63181c2ed74bc275c8.svg";
export { ForwardRef as ReactComponent };